import React, { memo, useMemo } from 'react';
import { useTitle } from '@gsa/afp-shared-ui-utils';
import { FilterTableFrame, Spinner } from '@gsa/afp-component-library';
import MyRequisitionsProvider from './MyRequisitionsProvider';
import MyRequisitionsFilters from './Filters/RequisitionsFilters';
import MyRequisitionsTable from './RequisitionsTable';
import './MyRequisitions.scss';
import ConfirmationMessages from './ConfirmationMessages/ConfirmationMessages';
import { useQuery } from '@apollo/client';
import { GET_ACTIVE_VEHICLE_GROUPS } from '../../services/data-layer/standards';
import { VEHICLE_GROUP_TAG_STORE } from '../../constants/constants';

const MyRequisitions = ({ setTab }) => {
  setTab('requisitions');
  useTitle('Requisitions and Orders-Requisitions');
  const [filters, setFilters] = React.useState([]);

  const { data: vehicleTypesData, loading: vehicleTypesLoading } = useQuery(GET_ACTIVE_VEHICLE_GROUPS,{
    fetchPolicy: 'no-cache',
    variables: {
      childTag: VEHICLE_GROUP_TAG_STORE
    }
  });

  const allVehicleTypes = useMemo(() => {
    const vehicleTypes =
      (vehicleTypesData && vehicleTypesData.getActiveVehicleGroups) || [];
    if (vehicleTypes) {
      sessionStorage.setItem('VEHICLE_TYPE_MAP', JSON.stringify(vehicleTypes));
    } else {
      return;
    }

    const sortedVehicleTypes = [...vehicleTypes];

    sortedVehicleTypes.sort((a, b) => {
      if (a.title < b.title) {
        return -1;
      }
      if (a.title < b.title) {
        return 1;
      }
      return 0;
    });

    return sortedVehicleTypes;
  }, [vehicleTypesData?.getActiveVehicleGroups]);

  const MyRequisitionsFrame = useMemo(() => FilterTableFrame(null, null, MyRequisitionsFilters, MyRequisitionsTable), []);

  return (
    <MyRequisitionsProvider>
      <div className="my-requisitions">
        <h2 className="usa-h2">Requisitions</h2>
        <ConfirmationMessages />

        {vehicleTypesLoading ? (
          <Spinner />
        ) : (
          <MyRequisitionsFrame
            filterToggle
            lowRightProps={{ filters }}
            lowLeftProps={{ setFilters, allVehicleTypes }}
          />
        )}
      </div>
    </MyRequisitionsProvider>
  );
};

export default memo(MyRequisitions);
